/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_EmbedInputs */



/**
* | output |
* | --- |
* | "Embed 608/708 Closed Captioning****" |
*
* @param {Signup_Compare_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_embed = /** @type {((inputs?: Signup_Compare_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "de") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "it") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "es") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
	return /** @type {LocalizedString} */ ("Embed 608/708 Closed Captioning****")
});